import React from 'react';
import { Box } from '@mui/material';
import { useInstatDesign } from '../theme/instatDesign';

/**
 * Sticky, frosted-glass top bar — Apple Navigation Bar feel.
 */
export default function GlassHeader({ children, sx = {}, stickyTop = 0 }) {
  const d = useInstatDesign();
  return (
    <Box
      sx={{
        position: 'sticky',
        top: stickyTop,
        zIndex: 10,
        bgcolor: d.colors.surfaceOverlay,
        backdropFilter: 'saturate(180%) blur(20px)',
        WebkitBackdropFilter: 'saturate(180%) blur(20px)',
        borderBottom: `1px solid ${d.colors.divider}`,
        boxShadow: d.shadows.glass,
        px: { xs: 2, md: 3 },
        py: 1.25,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
